import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Heading, HeadingVariant } from '@vizit/molecules';
import { HomePage } from '../../pages';
import { PagesProvider } from '../../pages/providers/pages-provider/pages-provider';
import { HOME_BREADCRUMB, beforeLoadAuthenticatedValidation, navigateWithState } from '../../router/route-utils';
import { NavbarPageTemplate } from '../../templates/navbar-page-template';

export const Route = createFileRoute('/_authenticated/')({
  staticData: {
    pageName: 'Home',
  },
  beforeLoad: async ({ context, location }) => beforeLoadAuthenticatedValidation(context, location),
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();

  const handleOnSuccessfulUpload = (id: string) => {
    navigateWithState(router, {
      to: '/library/assets/$id',
      params: { id },
      from: { trail: [HOME_BREADCRUMB] },
    });
  };

  const handleOnSuccessfulImport = (id: string) => {
    navigateWithState(router, {
      to: '/library/products/$id',
      params: { id },
      from: { trail: [HOME_BREADCRUMB] },
    });
  };

  const handleOnSuccessfulCreate = (id: string) => {
    navigateWithState(router, {
      to: '/library/products/$id',
      params: { id },
      from: { trail: [HOME_BREADCRUMB] },
      search: (prev: Record<string, unknown>) => ({ ...prev, products: 'open' }),
    });
  };

  const handleOnSuccessfulCollectionCreate = (id: string) => {
    navigateWithState(router, {
      to: '/library/collections/$collectionId',
      params: { collectionId: id },
      from: { trail: [HOME_BREADCRUMB] },
    });
  };

  return (
    <PagesProvider template={NavbarPageTemplate} templateProps={{ currentRoute: '/' }}>
      <div className="flex flex-col gap-8 pt-16 pb-40 pl-8 pr-12 max-sm:px-8 max-sm:py-8">
        <Heading variant={HeadingVariant.H1} className="text-display-md">
          Welcome to Vizit
        </Heading>
        <HomePage
          onSuccessfulUpload={handleOnSuccessfulUpload}
          onSuccessfulImport={handleOnSuccessfulImport}
          onSuccessfulCreate={handleOnSuccessfulCreate}
          onSuccessfulCollectionCreate={handleOnSuccessfulCollectionCreate}
        />
      </div>
    </PagesProvider>
  );
}
